import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'sonner';
import { apiGet, apiPost } from '../../lib/api';

const inputCls = 'w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-rozops-blue/20 focus:border-rozops-blue';

export default function CustomerVacation() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ start_date: '', end_date: '', reason: '' });
  const { selectedCustomerId, loadingProviders } = useOutletContext() || {};
  const allProviders = selectedCustomerId === 'all';

  const providerQuery = selectedCustomerId ? `?customer_id=${selectedCustomerId}` : '';
  useEffect(() => {
    if (loadingProviders) return;
    apiGet(`/customer/vacations${providerQuery}`).then(r => setList(r.data || [])).catch(() => {});
  }, [providerQuery, loadingProviders]);

  const submit = async (e) => {
    e.preventDefault();
    if (allProviders) {
      toast.error('Select one service provider before requesting vacation');
      return;
    }
    try {
      await apiPost(`/customer/vacations${providerQuery}`, form);
      toast.success('Vacation request sent');
      setForm({ start_date: '', end_date: '', reason: '' });
      const res = await apiGet(`/customer/vacations${providerQuery}`);
      setList(res.data || []);
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div className="space-y-4" data-testid="cust-vac">
      <h1 className="font-heading font-bold text-2xl text-rozops-navy">Vacation</h1>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-5 space-y-3">
        <div className="text-xs uppercase font-bold text-rozops-text-muted">Request pause</div>
        {allProviders && <div className="rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-700">Select one service provider before sending a vacation request.</div>}
        <div className="grid grid-cols-2 gap-3">
          <input required disabled={allProviders} type="date" className={inputCls} value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} data-testid="vac-start" />
          <input required disabled={allProviders} type="date" className={inputCls} value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} data-testid="vac-end" />
        </div>
        <input disabled={allProviders} placeholder="Reason (optional)" className={inputCls} value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} />
        <button disabled={allProviders} data-testid="vac-submit" className="bg-rozops-blue text-white rounded-xl px-4 py-2.5 font-semibold w-full sm:w-auto disabled:opacity-60">Submit request</button>
      </form>

      <div className="space-y-2">
        {list.length === 0 && <div className="text-sm text-rozops-text-muted text-center py-6">No vacation history.</div>}
        {list.map(v => (
          <div key={v.id} className="bg-white rounded-2xl border border-gray-100 p-4 flex justify-between items-center">
            <div>
              <div className="font-semibold text-rozops-text">{v.start_date} → {v.end_date}</div>
              {v.provider?.business?.business_name && <div className="text-xs text-rozops-text-muted">{v.provider.business.business_name}</div>}
              <div className="text-xs text-rozops-text-muted">{v.reason || '—'}</div>
            </div>
            <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${v.status === 'approved' ? 'bg-rozops-green-light text-rozops-green' : v.status === 'rejected' ? 'bg-red-50 text-red-500' : 'bg-amber-50 text-amber-700'}`}>{v.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
